<!-- Icon Tab Selection -->
<div style="display: flex;">
    <button class="ui icon mini button"
            style="padding: 0.2rem;"
            [class.yellow]="kesitAleti=='Kontrol'"
            (click)="kesitAleti='Kontrol';CD.detectChanges();"
            title="Düzlem Kontrolleri">
        <i class="icon sliders horizontal"
           style="width: 16px !important; height: 16px; font-size: 15px;"></i>
    </button>

    <button class="ui icon mini button"
            style="padding: 0.2rem;margin-left:auto;"
            [class.yellow]="kesitAleti=='Ayarlar'"
            (click)="kesitAleti='Ayarlar';CD.detectChanges();"
            title="Görsel Ayarlar">
        <i class="icon cog"
           style="width: 16px !important; height: 16px; font-size: 15px;"></i>
    </button>
</div>

<div class="ui divider"
     style="margin-top: 0.1rem; margin-bottom: 0.1rem;"></div>

<!-- Düzlem Kontrol Component -->
<fikoyt-duzlem-kontrol #FikoYTDuzlemKontrol
               [style.display]="kesitAleti=='Kontrol' ? 'block':'none'"
               *ngIf="dinamikKesit"
               [dinamikKesit]="dinamikKesit">
</fikoyt-duzlem-kontrol>

<!-- Ayarlar Component -->
<fikoyt-kesit-ayarlar #FikoYTKesitAyarlar
               [style.display]="kesitAleti=='Ayarlar' ? 'block':'none'"
               *ngIf="dinamikKesit"
               [dinamikKesit]="dinamikKesit"
               (ayarlarDegisti)="ayarlarGuncellendi($event)">
</fikoyt-kesit-ayarlar>

<div class="ui divider"
     style="margin-top: 0.3rem; margin-bottom: 0.3rem;"></div>

<!-- Footer -->
<div style="display: flex; align-items: center; gap: 0.4rem;">
    <button class="ui icon mini button"
            style="padding: 0.3rem; flex-shrink: 0;"
            [class.green]="kesitAktif"
            [class.red]="!kesitAktif"
            (click)="kesitiToggle()"
            [title]="kesitAktif ? 'Kesiti Durdur' : 'Kesiti Başlat'">
        <i class="icon" [class.stop]="kesitAktif" [class.play]="!kesitAktif"></i>
    </button>

    <span style="flex: 1; font-size: 11px; color: rgba(255,255,255,0.7);">
        {{ kesitAktif ? 'Kesit Aktif' : 'Kesit Kapalı' }}
    </span>

    <div class="ui animated mini button"
         tabindex="0"
         style="padding: 0.5rem;"
         (click)="kapa()">
        <div class="visible content">Kapat</div>
        <div class="hidden content">
            <i class="check icon"></i>
        </div>
    </div>
</div>
